import React, {useEffect, useRef, useState} from 'react';
import "./ProductRegalDesktopV2.scss";
import {useHistory} from "react-router-dom";
import {convertVariantTypeNameWithVal, getMallColor} from "../../Services";
import {getCats_api, getProductsCategory_api} from "../../Services/apis";
import {Swiper, SwiperSlide} from 'swiper/react';
import { Col, Row } from 'antd';
import SwiperId from "react-id-swiper";
import {PlusOutlined} from '@ant-design/icons';
import {useBasket, useDispatchBasket} from "../../hooks";
import {AddBasket, RemoveBasket} from "../OnlineAddress/OnlineAddressService";


const imageParamss = {
    slidesPerView: 'auto',
    spaceBetween: 10,
    rtl:true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    breakpoints: {
        1024: {
            slidesPerView: 5,
            spaceBetween: 20
        },
        768: {
            slidesPerView: 5,
            spaceBetween: 20
        },
        400: {
            slidesPerView: 'auto',
            spaceBetween: 8
        },
        320: {
            slidesPerView: 'auto',
            spaceBetween: 8
        }
    }

}


const catParams = {
    slidesPerView: 8,
    spaceBetween: 2,
    rtl:true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
}


function BasketAddRemoveSub({product,handleChangeProduct}) {

    //hooks
    const setBasket = useDispatchBasket();
    const basket = useBasket();
    const history = useHistory();

    //states
    const [loading, set_loading] = useState(false)
    const [base, set_base] = useState(product)
    const [item, set_item] = useState(null)
    const [merchantId,set_merchantId] = useState(product.merchant.uid)


    useEffect(() => {
        if(product?.variants?.length > 0) {
            set_item(product.variants[0])
        }else{
            set_item(product)
        }
    }, [])

    const addToBasket = async (pId) => {
        const response = await AddBasket(merchantId, pId,item)
        console.log("Add : ", response)
    }

    const removeFromBasket = async (pId) => {
        const response = await RemoveBasket(merchantId, pId)
        console.log("Remove : ", response)
    }

    //functions
    const inc = async () => {
        console.log("ssssssssssssssssssss")
        if (loading) {
            return
        }



        try {
            set_loading(true)
            //ADD API
            await addToBasket(item.uid);
            set_loading(false)
        } catch (e) {
            set_loading(false)
            return;
        }
        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        if (basket.find(product => product.product.uid === item.uid)) {
            //exist
            let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count: pro.count + 1} : pro)
            //context change
            setBasket(filter);
            //storage change
            localStorage.setItem("basket", JSON.stringify(filter));
        } else {
            //not exist

            //context change
            setBasket(oldArray => [...oldArray, {product: item, count: 1}]);
            //storage change
            localStorage.setItem("basket", JSON.stringify([...basket, {product: item, count: 1}]));
        }


    }

    const dec = async () => {
        if (loading) {
            return
        }
        try {
            set_loading(true)
            //Remove API
            await removeFromBasket(item.uid)
            set_loading(false)
        } catch (e) {
            set_loading(false)
            return;
        }

        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        let find = basket.find(product => product.product.uid === item.uid);
        if (find) {
            //exist
            if (find.count > 0) {
                //exist
                let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count: pro.count - 1} : pro)

                if (find.count === 1) {
                    //context change
                    setBasket(basket.filter(product => product.product.uid !== item.uid))
                    //storage change
                    localStorage.setItem("basket", JSON.stringify(basket.filter(product => product.product.uid !== item.uid)));
                } else {
                    //context change
                    setBasket(filter);
                    //storage change
                    localStorage.setItem("basket", JSON.stringify(filter));
                }
            } else {
                //context change
                setBasket(basket.filter(product => product.product.uid !== item.uid))
                //storage change
                localStorage.setItem("basket", JSON.stringify(basket.filter(product => product.product.uid !== item.uid)));
            }
        }


    }

    const remove = () => {
        //--------------------------------- Context Change ----------------------------------------------
        setBasket(basket.filter(product => product.product.uid !== item.uid))
        //--------------------------------- Local Storage Change ----------------------------------------------
        setTimeout(() => {
            localStorage.setItem("basket", JSON.stringify(basket));
        }, 500)
    }

    const checkCount = () => {
        if(!item)
            return 0

        let basket_count = basket.find(product => product.product.uid === item.uid);
        if (basket_count) {
            return basket_count.count;
        }
        return 0;
    }

    const handleVariantChange = (vId)=>{
        const  find = base.variants.find(v=>v.uid===vId)
        console.log("find : ",find)
        set_item(find)
        handleChangeProduct(find)
    }

    return (
        <div>
            {/*{base?.variants?.length > 0 ?*/}
            {/*    <div className="var-section">*/}
            {/*        <select*/}
            {/*            onChange={e=>{*/}
            {/*                handleVariantChange(e.target.value)*/}
            {/*            }}*/}
            {/*            name="" id="">*/}
            {/*            {base.variants.map(v=>{*/}
            {/*                return(*/}
            {/*                    <option value={v.uid}>{convertVariantTypeNameWithVal(v.variant_type,v.variant_attr)}</option>*/}
            {/*                )*/}
            {/*            })}*/}
            {/*        </select>*/}
            {/*    </div>:*/}
            {/*    null*/}
            {/*}*/}

            {item && checkCount() > 0?<div className="dr-shop-add-remove-v2-change">
                {item && checkCount() > 0 ? <>
                    <i className="clickable fa fa-minus" onClick={dec}></i>
                    <span className="plusIcon product-count-number-v2">{!loading ? checkCount() : <i className="fa fa-spinner fa-spin"></i>}</span>
                </> : null}
                {item.stock>checkCount()?
                    <i className="clickable fa fa-plus" onClick={inc}></i>:
                    <span></span>
                }

            </div>:null}

            {item && checkCount() < 1?<div>
                {!loading?<i className="clickable plusIcon fa fa-plus" onClick={inc}></i>:
                    <i className="plusIcon fa fa-spinner fa-spin"></i>
                }


            </div>:null}


        </div>
    )
}



function numberWithCommas  (x) {
    if (x === 0) {
        return 0
    }
    if(x){
        x= Math.round(x)
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    return "-"

}

function limitText(txt,length) {
    if(txt.length>length){
        return txt.substr(0,length)+" ... "
    }else {
        return txt
    }
}


function ProductV2Card({product,item}){

    const history = useHistory()

    const goToProductDetail = ()=>{
            history.push(`/dr-shop/detail/${product.merchant.uid}/${product.uid}`)
    }

    const [p,set_p] = useState(product)
    const handleChangeProduct = (pr)=>{
        console.log("product : ",pr)
        set_p(pr)
    }
    return(
        <div className="p-regal-desktop-v2-products-card">
            <div className="add-section">
                <BasketAddRemoveSub product={product}handleChangeProduct={handleChangeProduct}/>
            </div>
            <div className="p-regal-desktop-v2-products-card-wrapper" >
                <div className="p-regal-desktop-v2-products-card-img" onClick={e=>{
                    goToProductDetail()
                }}>
                    <img
                        src={product.image}
                        alt=""/>
                </div>
                <div className="p-regal-desktop-v2-products-card-divider">
                    {/*<PlusOutlined />*/}
                </div>
                <div className="p-regal-desktop-v2-products-card-info" onClick={e=>{
                    goToProductDetail()
                }}>
                    <span className="p-regal-desktop-v2-products-card-info-name">{limitText(product.name,50)}</span>
                    <span className="p-regal-desktop-v2-products-card-info-brand">سانستول</span>
                </div>

                <div className="p-regal-desktop-v2-products-card-footer" onClick={e=>{
                    goToProductDetail()
                }}>


                    <div className="p-regal-desktop-v2-products-card-footer-badge">
                        {product && product.discount_percentage && product.discount_percentage>0?<div className="p-regal-desktop-v2-products-card-footer-badge-off">
                            <span>%{product.discount_percentage}</span>
                        </div>:null}
                    </div>

                    <div className="p-regal-desktop-v2-products-card-footer-price">
                        {product.price_original-product.price>0?
                            <span className="p-regal-desktop-v2-products-card-footer-price-off">{numberWithCommas(product.price_original)}</span>:
                            <span></span>}
                        <span className="p-regal-desktop-v2-products-card-footer-price-price">{numberWithCommas(product.price)} تومان</span>
                    </div>

                </div>
            </div>
        </div>
    )
}

function ProductRegalDesktopV2({item,sort=false}) {


    const history = useHistory();

    const [merchantRegal,set_merchantRegal] = useState("")
    const [catRegal,set_catRegal] = useState("")

    const [regalFlag,set_regalFlag] = useState(true)
    const [data,setData] = useState([])
    const [cats,setCats] = useState([])
    const [currentCat,set_currentCat] = useState(null)
    const [color,setColor] = useState("#E0E0E0")



    const [mallPrimaryColor, set_mallPrimaryColor] = useState('');
    const [mallSecondaryColor, set_mallSecondaryColor] = useState('');

    useEffect(()=>{
        let {primary, secondary} = getMallColor()
        set_mallPrimaryColor(primary)
        set_mallSecondaryColor(secondary)
    },[])

    const [swiper, setSwiper] = useState(null);

    const ref = useRef(null);

    const goNext = () => {
        console.log(ref.current.swiper)
        if (ref.current !== null && ref.current.swiper !== null) {
            ref.current.swiper.slideNext();
        }
    };

    const goPrev = () => {
        if (ref.current !== null && ref.current.swiper !== null) {
            ref.current.swiper.slidePrev();
        }
    };


    useEffect( ()=>{
        getProductsMall()
    },[])

    const selectCat = (c)=>{
        set_currentCat(c)
        getCatProducts(c.uid)
        if(c.name)
            item.title = c.name
    }

    const [cat_banner,set_cat_banner] = useState("")
    const [cat_name,set_cat_name] = useState("")

    const getCatProducts = async (cId)=>{
        try{
            let split = item.items[0].text.split("@")
            //set for more product
            set_merchantRegal(split[1])
            // merchantRegal = split[1]
            console.log("cId : ",cId)
            // catRegal = cId
            set_catRegal(cId)
            const res = await getProductsCategory_api(split[1],cId)
            let proData = {data:res}
            set_regalFlag(false)
            setData(proData.data.results)
            set_cat_banner(proData.data.category_image)
            set_cat_name(proData.data.category_name)
            set_regalFlag(true)
            if(item.items[0].link_to_uid)
                setColor(item.items[0].link_to_uid)
        }catch (e) {
            console.log(e)
        }

    }


    const getProductsMall = async ()=>{
        if(item.items[0].text){
            try{
                let split = item.items[0].text.split("@")
                //set for more product
                // merchantRegal = split[1]
                set_merchantRegal(split[1])
                console.log("split[0] : ",split[0])
                // catRegal = split[0]
                set_catRegal(split[0])

                const res = await getProductsCategory_api(split[1],split[0])
                let proData = {data:res}
                setData(proData.data.results)
                set_cat_banner(proData.data.category_image)
                set_cat_name(proData.data.category_name)
                selectCat({uid:split[0]})
                getCats(split[1],split[2])
                if(item.items[0].link_to_uid)
                    setColor(item.items[0].link_to_uid)
            }catch(e){
                console.log(e)
            }
        }
    }

    const getCats = async(mId,pId)=>{
        try{
            const res = await getCats_api(mId,pId)
            // let data = res.data.result
            let proData = {data:res}
            setCats(proData.data)
        }catch (e) {
            console.log(e)
        }
    }


    const seeMoreProduct = ()=>{

        console.log("Cat : ",catRegal)
        console.log("Merchant : ",merchantRegal)

        history.push(`/dr-shop/search/${merchantRegal}/${catRegal}`)
    }

    const [sortSelect,set_sortSelect] = useState("discounts")
    const handleChangeSort = async (val)=>{
        set_sortSelect(val)
        // selectCat(currentCat)
        try{
            let split = item.items[0].text.split("@")
            //set for more product
            // merchantRegal = split[1]
            set_merchantRegal(split[1])
            // catRegal = currentCat.uid
            set_catRegal(currentCat.uid)
            console.log("-------------------------------------",val)
            const res = await getProductsCategory_api(split[1],currentCat.uid,val)
            let proData = {data:res}
            setData(proData.data.results)
            if(item.items[0].link_to_uid)
                setColor(item.items[0].link_to_uid)
        }catch (e) {
            console.log(e)
        }
    }



    return(
        <div className="p-regal-desktop-v2-container">
            <Row className="v2-wrapper" style={{backgroundColor:color}}>
                <Col className="left-slider v2-card-color"  span={20}>
                    <div  className="p-regal-desktop-v2-cats">
                                {cats && cats.length>0 && cats.slice(0,5).map(d=>{
                                    return(
                                        <div className={currentCat?.uid===d.uid?"p-regal-desktop-v2-cats-item active-item":"p-regal-desktop-v2-cats-item"}  onClick={e=>{
                                            selectCat(d)
                                        }}>
                                            <span>{d.name}</span>
                                        </div>
                                    )
                                })}
                    </div>
                    <Row>
                        <Swiper
                            // autoplay={{
                            //     delay: 3000,
                            //     pauseOnMouseEnter: true,
                            //     disableOnInteraction: false
                            // }}
                            spaceBetween={10}
                            slidesPerView={4}
                            onSlideChange={() => console.log('slide change')}
                            onSwiper={(swiper) => console.log(swiper)}
                        >

                            {/*{leftData.map(item=>{*/}
                            {/*    return(*/}
                            {/*        <SwiperSlide>*/}
                            {/*            <img alt={"slider"+item.uid}  src={item.image} />*/}
                            {/*        </SwiperSlide>*/}
                            {/*    )*/}
                            {/*})}*/}
                            {data.map(i=>{
                                return(
                                        <SwiperSlide>
                                        <ProductV2Card item={item} product={i}/>
                                        </SwiperSlide>
                                )
                            })}
                        </Swiper>

                    </Row>

                </Col>

                <Col className="right-slider" span={4}>
                    <div className="p-regal-desktop-v2-banner-sec">
                        <img src={cat_banner} alt=""/>
                        <h6>{cat_name}</h6>
                        <span className="clickable" onClick={seeMoreProduct}>مشاهده همه</span>
                    </div>
                </Col>

            </Row>




        </div>
    )
}

export default ProductRegalDesktopV2;
